module.exports = __webpack_public_path__ + "static/img/onyx.5edda16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/onyx.png
// module id = nD/0
// module chunks = 0